import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, CheckIcon, GiftIcon, XCircleIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-20" data-id="element-124" data-mp="18jumnvty6dm2">
      <div className="mx-auto max-w-4xl" data-id="element-125" data-mp="18hhwive1cwxx">
        <div className="text-center" data-id="element-126" data-mp="25a3ktcr8dh9t">
          <SectionLabel data-id="element-127" data-mp="25928z62e4qr1">Bonus esclusivi</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl md:text-[42px]" data-id="element-128" data-mp="20a8vver0n1re">
            In più riceverai questi 5 bonus esclusivi{' '}
            <em className="not-italic text-kidney-dark" data-id="element-129" data-mp="1rac95io6scyz">GRATIS</em>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-navy/75 sm:text-lg" data-id="element-130" data-mp="1rcf2abkmym7x">
            Creati per eliminare le situazioni che generano più dubbi e incertezza nella
            pratica clinica quotidiana.
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-5 sm:mt-12" data-id="element-131" data-mp="1euyem6ve4hdd">
          {bonuses.map(bonus => <article key={bonus.id} className="rounded-3xl border border-kidney/25 bg-white p-4 sm:p-7" data-id="element-132" data-mp="1jrgiz5mt6dp6">
              <img src={bonus.image} alt={`Mockup di ${bonus.title}`} className="mx-auto w-full max-w-[420px] sm:max-w-[520px]" width={1260} height={1260} loading="lazy" data-id="element-133" data-mp="1as1pryf9bp0z" />

              <div className="mt-2 flex items-center gap-2 sm:mt-4" data-id="element-134" data-mp="10vynmskenqe1">
                <GiftIcon className="h-4 w-4 text-kidney-dark" aria-hidden="true" data-id="element-135" data-mp="n3sdbn3xodmi" />
                <span className="text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-kidney-dark" data-id="element-136" data-mp="r5425qezgutn">
                  {bonus.label}
                </span>
              </div>

              <h3 className="mt-2.5 font-display text-[21px] font-extrabold leading-tight text-navy-deep sm:text-[26px]" data-id="element-137" data-mp="i3xmtko2lq1z">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[14.5px] font-semibold leading-relaxed text-navy-deep sm:text-base" data-id="element-138" data-mp="2f1v5h69veqku">
                {bonus.promise}
              </p>

              {bonus.intro ? <p className="mt-3 text-[14px] leading-relaxed text-navy/75" data-id="element-139" data-mp="2axvqwt85i1u4">
                  {bonus.intro}
                </p> : null}

              {bonus.quotes ? <ul className="mt-3 flex flex-col gap-2" data-id="element-140" data-mp="32pbo1h7c36yl">
                  {bonus.quotes.map(quote => <li key={quote} className="rounded-xl bg-cream px-3.5 py-2.5 font-display text-[14.5px] font-semibold italic text-navy-deep" data-id="element-141" data-mp="2ynzuj0lca1l4">
                      {quote}
                    </li>)}
                </ul> : null}

              {bonus.listTitle ? <p className="mt-5 text-[12px] font-extrabold uppercase tracking-[0.12em] text-navy/55" data-id="element-142" data-mp="1dbpyncsy37b7">
                  {bonus.listTitle}
                </p> : null}

              {bonus.items ? <ul className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-6" data-id="element-143" data-mp="187xbd9jcef3q">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-144" data-mp="1hxgxco2cqp2t">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney" aria-hidden="true" data-id="element-145" data-mp="1hz0bo94g6q1y" />
                      <span className="text-[14px] leading-snug text-navy/85" data-id="element-146" data-mp="1qx3yr9v2zuvv">
                        {item}
                      </span>
                    </li>)}
                </ul> : null}

              {bonus.id === 'bonus-4' ? <div className="mt-4 rounded-2xl bg-cream px-4 py-4" data-id="element-147" data-mp="1jgy7fbbz3gm">
                  <p className="text-[12px] font-extrabold uppercase tracking-[0.12em] text-navy/55" data-id="element-148" data-mp="1la8d4l5k5td">
                    Per ogni errore troverai:
                  </p>
                  <ul className="mt-2.5 flex flex-col gap-2 text-[13.5px] font-semibold text-navy-deep" data-id="element-149" data-mp="1wy2tn75en76u">
                    <li className="flex items-center gap-2" data-id="element-150" data-mp="1rzszmzvf2cmt">
                      <XCircleIcon className="h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-151" data-mp="260luxmtjlbqz" />
                      Cosa succede
                    </li>
                    <li className="flex items-center gap-2" data-id="element-152" data-mp="20ywj44yhwu1u">
                      <AlertTriangleIcon className="h-4 w-4 shrink-0 text-amber-500" aria-hidden="true" data-id="element-153" data-mp="1dcgbd3e85ssq" />
                      Perché è importante
                    </li>
                    <li className="flex items-center gap-2" data-id="element-154" data-mp="1n0y8nanaphrm">
                      <CheckCircle2Icon className="h-4 w-4 shrink-0 text-kidney" aria-hidden="true" data-id="element-155" data-mp="1n2j4r4p9d8rl" />
                      Cosa fare invece
                    </li>
                  </ul>
                </div> : null}

              <div className="mt-5 flex flex-wrap items-center gap-2.5 border-t border-navy-deep/10 pt-4" data-id="element-156" data-mp="pm3tp0t6ghoy">
                <span className="text-[12px] font-bold uppercase tracking-[0.1em] text-navy/50 line-through" data-id="element-157" data-mp="318ntmto60k1o">
                  Valore: {bonus.value}
                </span>
                <span className="rounded-full bg-kidney px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-158" data-mp="361qrhdzz6fno">
                  Incluso gratis
                </span>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-159" data-mp="3kyhs1qldxxev">
          <CtaButton label="Voglio i 6 volumi + i 5 bonus" sub="Valore totale €292 — oggi incluso nel tuo accesso" data-id="element-160" data-mp="3oyrzl7otsvvu" />
        </div>
      </div>
    </section>;
}